import { render, staticRenderFns } from "./FundingProjects.vue?vue&type=template&id=24ef5786&scoped=true&"
import script from "./FundingProjects.vue?vue&type=script&lang=ts&"
export * from "./FundingProjects.vue?vue&type=script&lang=ts&"
import style0 from "./FundingProjects.vue?vue&type=style&index=0&id=24ef5786&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef5786",
  null
  
)

export default component.exports